export default {
  fullscreen({commit}) {
    const document = window.document;
    const documentElement = document.documentElement;
    const requestFullScreen = documentElement.requestFullscreen || documentElement.mozRequestFullScreen || documentElement.webkitRequestFullScreen || documentElement.msRequestFullscreen;
    const cancelFullScreen = document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen;
    (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) ?
      requestFullScreen.call(documentElement) : cancelFullScreen.call(documentElement);

    commit('fullscreen');
  },

  toggleDrawer(context) {
    context.commit('toggleDrawer');
  },

  toggleNotification(context, payload) {
    context.commit('toggleNotification', payload);
  },

  /**
   * Dispatch a delayed action.
   *
   * The action will be dispatched after the specified time delay in seconds.
   *
   * @param dispatch
   * @param commit
   * @param name {String} The name of the action to dispatch after the delay
   * @param delay {Integer} The number of seconds to wait before dispatching the action.
   * @param args {Object} The arguments that will be passed to the action when it is dispatched.
   * @returns {Promise<void>}
   */
  delayed({dispatch, commit}, {name, delay, args}) {
    setTimeout(() => dispatch(name, args), delay);
  },
}
